import { BarChartIcon, ChatIcon, CloudIcon, CodeIcon, ConsoleIcon, SecurityIcon, ServerIcon } from './labs-icons.react-component';
export const LAB_VERTICAL = Object.freeze({
  aws: {
    key: 'aws',
    label(gettext) {
      return gettext('AWS');
    },
    glyph: 'cloud',
    iconComponent: CloudIcon
  },
  azure: {
    key: 'azure',
    label(gettext) {
      return gettext('Azure');
    },
    glyph: 'cloud',
    iconComponent: CloudIcon
  },
  gcp: {
    key: 'gcp',
    label(gettext) {
      return gettext('Google Cloud Provider');
    },
    glyph: 'cloud',
    iconComponent: CloudIcon
  },
  web: {
    key: 'web',
    label(gettext) {
      return gettext('Web');
    },
    glyph: 'code',
    iconComponent: CodeIcon
  },
  data_science: {
    key: 'data_science',
    label(gettext) {
      return gettext('Data Science');
    },
    glyph: 'bar-chart',
    iconComponent: BarChartIcon
  },
  devops: {
    key: 'devops',
    label(gettext) {
      return gettext('DevOps');
    },
    glyph: 'server',
    iconComponent: ServerIcon
  },
  security: {
    key: 'security',
    label(gettext) {
      return gettext('Security');
    },
    glyph: 'security',
    iconComponent: SecurityIcon
  },
  it_ops: {
    key: 'it_ops',
    label(gettext) {
      return gettext('IT Ops');
    },
    glyph: 'console',
    iconComponent: ConsoleIcon
  },
  gen_ai: {
    key: 'gen_ai',
    label(gettext) {
      return gettext('Gen AI');
    },
    glyph: 'chat',
    iconComponent: ChatIcon
  }
});
export const TOPIC_TO_LAB_VERTICAL_MAP = Object.freeze({
  4452: 'aws',
  6716: 'azure',
  8322: 'web',
  5336: 'data_science',
  5404: 'devops',
  5988: 'gcp',
  5316: 'security',
  7964: 'it_ops',
  158078: 'gen_ai'
});
export const LAB_INSTANCE_STATUS = {
  starting: 'starting',
  running: 'running',
  queued: 'queued',
  stopping: 'stopping',
  stopped: 'stopped',
  killing: 'killing',
  killed: 'killed',
  admin_killing: 'admin_killing',
  admin_killed: 'admin_killed',
  deactivated: 'deactivated',
  error: 'error'
};
export const LAB_LANDING_PAGE_URL = '/labs/listing/';
export const LAB_STATUS = {
  pending_create: 'creating',
  draft: 'draft',
  in_review: 'in_review',
  pending_publish: 'publishing',
  published: 'published',
  unpublished: 'unpublished',
  deleted: 'deleted'
};
export const LAB_ACCESS_LEVEL = {
  base: 'base',
  test_creator: 'test-creator',
  edit: 'edit',
  full: 'full',
  admin: 'admin',
  admin_eng: 'admin-eng'
};
export const LAB_MODE = {
  FOLLOW_ALONG: 'follow_along',
  STRUCTURED: 'structured',
  OPEN: 'open'
};
export const labLoadingUrl = labId => `/labs/${labId}/loading/`;
export const LABS_MODULAR_URL_PATTERN = '/labs/';
export const LAB_CLICK_TRACKING_ACTIONS = Object.freeze({
  END_CONFIRM: 'end_confirm'
});
export const LAB_TYPE = Object.freeze({
  workspace: {
    key: 'workspace',
    label(gettext) {
      return gettext('Workspace');
    }
  },
  modular: {
    key: 'modular',
    label(gettext) {
      return gettext('Modular Lab');
    }
  },
  dev_workspace: {
    // development workspace for instructors, which is used temporarily for testing ideas
    key: 'dev_workspace',
    label(gettext) {
      return gettext('Instructor Development Workspace');
    }
  }
});
export const LAB_LAUNCHER_FEEDBACK = Object.freeze({
  TERMINATE_LAB_FEEDBACK(gettext) {
    return gettext('There was a problem terminating your lab. Please refresh your browser and try again.');
  }
});
export const LAB_EXTENDED_WORKSPACE_TIME_LIMIT_DAYS = 14;
export const MODULAR_LAB_TIME_LIMIT_HOURS = 3;
export const LAB_TIME_LIMIT_MINUTES = {
  [LAB_TYPE.workspace.key]: 30,
  [LAB_TYPE.modular.key]: MODULAR_LAB_TIME_LIMIT_HOURS * 60,
  [LAB_TYPE.dev_workspace.key]: 30
};
export const LAB_VERTICALS_WITHOUT_PAUSE_RESUME = [LAB_VERTICAL.azure.key, LAB_VERTICAL.aws.key, LAB_VERTICAL.gcp.key];
export const LABS_DISCOVER_COMPONENTS = Object.freeze({
  MY_LEARNING_SHOW_LABS: 'my_learning_show_labs',
  MY_LEARNING_LABS_TAB: 'my_learning_labs_tab',
  MY_LEARNING_LABS_PAGE: 'my_learning_labs_page',
  LABS_LANDING_PAGE: 'labs_landing_page',
  LABS_IN_COURSE_PROMPT: 'labs_in_course_prompt',
  LABS_IN_SEARCH: 'labs_in_search',
  LABS_UNIT_LIHP: 'labs_unit_lihp',
  LABS_UNIT_TOPIC: 'labs_unit_topic',
  LAB_OVERVIEW_PAGE: 'lab_overview_page',
  LAB_LISTING_PAGE: 'lab_listing_page',
  LAB_CARD_QUICK_PREVIEW: 'quick_preview',
  LAB_RECOMMENDATION: 'lab_recommendation'
});
export const LAB_TRACKING_SELECTED_UI_REGION = Object.freeze({
  MY_LEARNING_UNIT_LABS_TAB: 'my_learning_unit_labs_tab',
  MY_LEARNING_PAGE_LABS_TAB: 'my_learning_page_labs_tab',
  LABS_LANDING_PAGE_SEARCH_RESULTS: 'labs_landing_page_search_results',
  LABS_IN_COURSE_PROMPT: 'labs_in_course_prompt',
  LABS_IN_SEARCH: 'labs_in_search',
  LABS_UNIT_LIHP: 'labs_unit_lihp',
  LABS_UNIT_TOPIC: 'labs_unit_topic',
  LABS_RELATED_UNIT: 'labs_related_unit',
  LABS_IN_PROGRESS_UNIT: 'labs_in_progress_unit',
  LAB_CARD_QUICK_PREVIEW: 'quick_preview',
  LAB_RECOMMENDATION: 'lab_recommendation'
});
export const LAB_TRACKING_SELECTED_UI_REGION_MAPPING = Object.freeze({
  [LABS_DISCOVER_COMPONENTS.MY_LEARNING_LABS_TAB]: LAB_TRACKING_SELECTED_UI_REGION.MY_LEARNING_UNIT_LABS_TAB,
  [LABS_DISCOVER_COMPONENTS.MY_LEARNING_LABS_PAGE]: LAB_TRACKING_SELECTED_UI_REGION.MY_LEARNING_PAGE_LABS_TAB,
  [LABS_DISCOVER_COMPONENTS.LABS_LANDING_PAGE]: LAB_TRACKING_SELECTED_UI_REGION.LABS_LANDING_PAGE_SEARCH_RESULTS,
  [LABS_DISCOVER_COMPONENTS.LABS_IN_COURSE_PROMPT]: LAB_TRACKING_SELECTED_UI_REGION.LABS_IN_COURSE_PROMPT,
  [LABS_DISCOVER_COMPONENTS.LABS_IN_SEARCH]: LAB_TRACKING_SELECTED_UI_REGION.LABS_IN_SEARCH,
  [LABS_DISCOVER_COMPONENTS.LABS_UNIT_LIHP]: LAB_TRACKING_SELECTED_UI_REGION.LABS_UNIT_LIHP,
  [LABS_DISCOVER_COMPONENTS.LABS_UNIT_TOPIC]: LAB_TRACKING_SELECTED_UI_REGION.LABS_UNIT_TOPIC,
  [LABS_DISCOVER_COMPONENTS.LAB_LISTING_PAGE]: LAB_TRACKING_SELECTED_UI_REGION.LABS_IN_PROGRESS_UNIT,
  [LABS_DISCOVER_COMPONENTS.LAB_OVERVIEW_PAGE]: LAB_TRACKING_SELECTED_UI_REGION.LABS_RELATED_UNIT,
  [LABS_DISCOVER_COMPONENTS.LAB_CARD_QUICK_PREVIEW]: LAB_TRACKING_SELECTED_UI_REGION.LAB_CARD_QUICK_PREVIEW,
  [LABS_DISCOVER_COMPONENTS.LAB_RECOMMENDATION]: LAB_TRACKING_SELECTED_UI_REGION.LAB_RECOMMENDATION
});
export const SEARCH_PAGE = 'search';
export const LAB_UI_REGION = Object.freeze({
  LAUNCHER: 'lab_launcher',
  MODE_SELECTOR: 'lab_mode_selector',
  REVIEW_IN_PROGRESS_LABS_MODAL: 'review_in_progress_labs_modal'
});
//# sourceMappingURL=constants.js.map